@if (!appInfo.graafschap) {
  <div class="m-3">
    <h2>Features coming in the future:</h2>
    <ul>
      <li>Totals of Giving per Account?</li>
      <li>Totals for Month and YTD?</li>
      <li>Actual vs. Budget?</li>
      <li>Pretty Bar and Pie Graphs?</li>
    </ul>
  </div>
}

@if (appInfo.graafschap) {
  <div class="m-3">
    <h2>Giving Overview</h2>
    @if (appInfo.graafschap) {
      <div style="margin-left: 50px">
        <a href="/app/assets/EnteringOffering.pdf" target="_blank"><b>Entering an Offering</b></a
        ><br />
        <a href="/app/assets/DesignatedDonations.pdf" target="_blank"><b>Entering a Split Donation</b></a
        ><br />
        <a href="/app/assets/Thanksgiving.pdf" target="_blank"><b>Thanksgiving Offering Instructions</b></a
        ><br />
        <!-- <a href="/app/assets/Release Notes.pdf" target="_blank"><b>Release Notes</b></a> -->
      </div>
    }
    <!-- <dx-chart class="mt-3" id="offeringChart" [dataSource]="offeringHistory" title="Offerings">
    <dxo-common-series-settings
      type="bar"
      argumentField="date"
      valueField="amount"
      [ignoreEmptyPoints]="true"
    ></dxo-common-series-settings>
    <dxi-series valueField="amount" name="Total"> </dxi-series>
    <dxo-argument-axis [visualRange]="visualRangeOffering"> </dxo-argument-axis>
    <dxo-tooltip
      [enabled]="true"
      [format]="{ type: 'currency', precision: '2' }"
      [customizeTooltip]="customizeToolTipOfferingHistory"
    ></dxo-tooltip>
    <dxi-value-axis>
      <dxo-title text="Total Amount"></dxo-title>
    </dxi-value-axis>
  </dx-chart>
  <dx-range-selector [dataSource]="offeringHistory" dataSourceField="date" [(value)]="visualRangeOffering">
    <dxo-size [height]="80"></dxo-size>
    <dxo-scale valueType="datetime" tickInterval="week" minorTickInterval="week" [endOnTick]="true" [minorTick]="{ visible: false }">
      <dxo-label format="shortDate"></dxo-label>
    </dxo-scale>
    <dxo-slider-marker format="shortDate"></dxo-slider-marker>
    <dxo-behavior callValueChanged="onMoving"></dxo-behavior>
  </dx-range-selector> -->
</div>
}
